import * as types from "./types";

export default {
  [types.SET_INITIAL_DATA](state, data) {
    state.status = {
      consultant_id: data.consultant.id,
      consultant_name: data.consultant.name,
      consultant_code: data.consultant.code,
      avatar: data.consultant.avatar,
      current_role: data.consultant.current_role,
      target_role_id: data.targetRole?.id || undefined,
      target_role: data.targetRole?.name || undefined,
      target_role_description: data.targetRole?.description || undefined,
      promotion_reason_id: data.promotionReason?.id || undefined,
      promotion_reason: data.promotionReason?.name || undefined,
      promotion_reason_description:
        data.promotionReason?.description || undefined,
      current_step: data.currentStep,
      finished_at: data.isCompleted
        ? data.steps.find((s) => s.step === data.currentStep)?.finished_at
        : null,
    };

    state.steps = data.steps.map((s) => ({
      number: s.step,
      title: s.title,
      subtitle: s.subtitle,
      finished_at: s.finished_at,
      items: s.items.map((i) => ({
        id: i.item_id,
        description: i.description,
        type: i.type,
        item_order: i.item_order ?? 1,
        mandatory: i.mandatory,
        signer_email: i.signer_email,
        signer_info: i.signer_info,
        value: i.financial_solution_value || i.signer_email,
        lead_owner: i.consultant_lead_owner_id,
        seller: i.consultant_seller_id,
        finished_at: i.finished_at,
        document_signature_id: i.document_signature_id,
        signatures: i.signatures || [],
      })),
    }));
  },
};
